import type { JourneyQuoteSubscriptionRow } from './JourneyQuoteSummaryColumn';
import type { Product } from '~/store/slices/quote/types';

export type BuildQuoteSubscriptionRowsInput = {
  products: Pick<Product, 'product_id' | 'product_name' | 'product_price'>[];
  flat_rate?: number;
  plan_club_name?: string;
  plan_club_description?: string;
  plan_has_club?: boolean;
};

export function buildQuoteSubscriptionRows({
  flat_rate,
  plan_club_description,
  plan_club_name,
  plan_has_club,
  products
}: BuildQuoteSubscriptionRowsInput): JourneyQuoteSubscriptionRow[] {
  const rows: JourneyQuoteSubscriptionRow[] = [];
  if (plan_has_club && flat_rate !== undefined && flat_rate > 0 && plan_club_name) {
    rows.push({
      amount: flat_rate,
      description: plan_club_description,
      id: 'plan-club-flat',
      label: plan_club_name
    });
  }
  for (const p of products) {
    rows.push({
      amount: p.product_price,
      id: String(p.product_id),
      label: p.product_name
    });
  }
  return rows;
}
